<template>
  <v-container fluid style="max-width: 99% !important;padding-bottom: 125px;">
    <v-row justify="space-around">
      <v-col
        cols="12"
        sm="12"
        style="text-align: initial; line-height: normal;min-width: 130px;padding-top: 0px;"
        v-if="itemsAwait"
      >
        <v-card :color="whitesmoke">
          <v-card-text class="subtitle4Text py-3">
            {{ titleAwait }}
            <v-progress-linear
              indeterminate
              :color="colorTheme"
              class="mb-0"
              style="margin-top: 10px;"
            ></v-progress-linear>
          </v-card-text>
          <v-card-actions>
            <v-btn class="regularText" :color="colorTheme" text @click="cancel()">{{ $t("cancel").toUpperCase() }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>

      <v-row justify="space-around" style="display: contents;">
          <v-col
            v-for="(item, index) in ItemsDashboard"
            v-bind:key="index"
            cols="12"
            lg="2"
            md="4"
            sm="6"
            xs="12"
            style="text-align: initial; line-height: normal;min-width: 130px;"
          >
            <v-card height="135px" style="display: grid;" v-if="viewSkeletons" :color="whitesmoke">
              <v-col cols="12">
                <div :class="skeleton" :style="backgroundSkeleton"></div>
              </v-col>
              <v-col cols="12">
                <div :class="skeleton" :style="backgroundSkeleton"></div>
              </v-col>
            </v-card>
            <v-card height="135px" style="display: grid;" :color="whitesmoke" v-else>
              <v-row style="display: contents;">
                <v-divider
                  light
                  vertical
                  :color="colorTheme"
                  style="position: absolute;border-width: 2px;"
                ></v-divider>
                <v-col cols="12">
                  <div class="regularText">{{ item.title }}</div>
                </v-col>

                <!-- Utilizar para cuando se realice cambio "Mostrar lista de equipos que tienen alertruck en el periodo seleccionado" -->
                <!-- <v-col cols="12" v-if="item.title == $t('vehicles')">
                  <div
                    class="cardValueText font-weight-medium my-2"
                    @click="showAlertruckVehicles"
                  ><span style="cursor: pointer;">{{ item.value }}</span></div>
                </v-col> -->

                <!-- Agregar v-else cuando se realice cambio "Mostrar lista de equipos que tienen alertruck en el periodo seleccionado" -->
                <v-col cols="12">
                  <div class="cardValueText font-weight-medium my-2">{{ item.value }}</div>
                </v-col>

              </v-row>
            </v-card>
          </v-col>
      </v-row>

      <v-row justify="space-around" style="display: contents;">
          <v-col v-for="(item, index) in itemsDashboardCharts" v-bind:key="index" v-if="item.value == 1" sm="12" lg="3" md="4" cols="12">
            <v-card v-if="viewSkeletons" :color="whitesmoke">
              <v-col cols="12">
                <div :class="skeletonTitle" :style="backgroundSkeleton"></div>
              </v-col>
              <v-col cols="12">
                <div :class="skeletonPie" :style="backgroundSkeleton"></div>
              </v-col>
              <v-col cols="12">
                <div :class="skeletonFooter" :style="backgroundSkeleton"></div>
              </v-col>
            </v-card>
            <v-card :color="whitesmoke">
              <highcharts :id="item.title"></highcharts>
            </v-card>
          </v-col>

          <v-col sm="12" lg="9" md="8" cols="12" v-else>
            <v-card v-if="viewSkeletons" :color="whitesmoke">
              <v-col cols="12">
                <div :class="skeletonTitle" :style="backgroundSkeleton"></div>
              </v-col>
              <v-col cols="12">
                <div :class="skeletonColumn" :style="backgroundSkeleton"></div>
              </v-col>
            </v-card>
            <v-card :color="whitesmoke" v-on:click="changeToDetails(item.title)">
              <highcharts :id="item.title"></highcharts>
            </v-card>
          </v-col>
      </v-row>
    </v-row>
  </v-container>
</template>

<script>
import { Chart } from "highcharts-vue";
import i18n from "@/plugins/i18n";
import { mapState } from "vuex";
import moment from "moment";

export default {
  name: "dashboard",
  components: {
    highcharts: Chart
  },
  data() {
    return {
      authenticated: false
    };
  },
  created() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
    this.$store.commit("setTitle", "ALERTRUCK");
    this.$store.commit("setPageHeader", [
      this.$t("dashboard"),
      "",
      "",
      "",
      true
    ]);
    this.$store.commit("skeleton", "outskeleton");
    this.$store.commit("skeletonTitle", "outskeletonTitle");
    this.$store.commit("skeletonPie", "outskeletonPie");
    this.$store.commit("skeletonFooter", "outskeletonFooter");
    this.$store.commit("skeletonColumn", "outskeletonColumn");

    var datesDash = JSON.parse(localStorage.getItem("PeriodTitle"));
    if (datesDash != undefined) {
      this.$store.commit("setPeriodTitleDates", datesDash);
    } else {
      var today = moment().format("YYYY-MM-DD");
      this.$store.commit("setPeriodTitleDates", [today]);
    }
  },
  computed: {
    ...mapState([
      "ItemsDashboard",
      "colorTheme",
      "viewSkeletons",
      "itemsDashboardCharts",
      "backgroundSkeleton",
      "itemsAwait",
      "whitesmoke",
      "titleAwait",
      "start"
    ]),
    skeleton: {
      get: function() {
        return this.$store.state.skeleton;
      },
      set: function() {}
    },
    skeletonTitle: {
      get: function() {
        return this.$store.state.skeletonTitle;
      },
      set: function() {}
    },
    skeletonPie: {
      get: function() {
        return this.$store.state.skeletonPie;
      },
      set: function() {}
    },
    skeletonFooter: {
      get: function() {
        return this.$store.state.skeletonFooter;
      },
      set: function() {}
    },
    skeletonColumn: {
      get: function() {
        return this.$store.state.skeletonColumn;
      },
      set: function() {}
    }
  },
  watch: {
    start() {
      this.$store.dispatch("getItemsDashboard", [false, false]);
    }
  },
  mounted() {
    if (this.$store.state.start) {
      this.$store.dispatch("getItemsDashboard", [false, false]);
    }
    this.$store.commit("UnitSystemValues");
    this.$store.commit("backgroundSkeleton");
  },
  methods: {
    cancel() {
      this.$store.commit("viewAwait", [false, ""]);
      this.$store.commit("disableButton", false);
      //cancelar peticion
      this.$store.dispatch("cancelData");
      this.$store.dispatch("setSkeletons", [false, ""]);
      localStorage.removeItem("ItemsDashboard");
    },
    changeToDetails(val) {
      if (val == "MoreExceptions") {
        this.$router.push({ name: "inTransitIncidents" });
      } else {
        this.$store.commit("titleOfGraphic", val);
        this.$router.push({ name: "performance" });
      }
    },
    showAlertruckVehicles() {
      this.$router.push({ name: "alertruckVehiclesInfo" });
    }
  }
};
</script>
<style>
.iconsDash {
  height: 30%;
  position: absolute;
  margin-left: 65%;
}

.myLayout {
  display: contents;
  text-align: center;
}

@import "./../assets/styles/skeletons.css";
</style>
